var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo, useState, useEffect, useRef, } from 'react';
import { useField, useFormikContext } from 'formik';
import { useFormikFieldValidation } from '../components/molecules/FormikForm/';
import { getDisplayName } from '../utils/getDisplayName';
import { useScrollingToHigherItem } from '../components/molecules/FormikForm/scrollingToErrors.context';
/**
 * note!: do not use "touched" from formik.field.meta, since preferred behaviour
 * required to change it on submitting and its dramatically influence on performance
 * of submit
 */
export function withFormikField(EnhancedComponent) {
    var WithFormikField = function (props) {
        var _a = useState(false), isDirty = _a[0], setIsDirty = _a[1];
        var _b = useState(false), touched = _b[0], setTouched = _b[1];
        var wrapperRef = useRef(null);
        var _c = useState(false), hasOnSubmitError = _c[0], setHasOnSubmitError = _c[1];
        var isSubmitting = useFormikContext().isSubmitting;
        var validateSelf = useFormikFieldValidation(props).validateSelf;
        var scrollToHigherItem = useScrollingToHigherItem();
        var _d = useField(props), field = _d[0], meta = _d[1], helpers = _d[2];
        var error = meta.error;
        var setValue = helpers.setValue;
        useEffect(function () {
            if (isSubmitting) {
                // Seems that Formik has bug with setting of "touched" onSubmitting
                setTouched(false);
                if (!!error) {
                    setHasOnSubmitError(true);
                    if (wrapperRef.current !== null) {
                        scrollToHigherItem(wrapperRef.current);
                    }
                }
            }
        }, [isSubmitting, error, scrollToHigherItem]);
        var handleChange = useCallback(function (value) {
            !isDirty && setIsDirty(true);
            hasOnSubmitError && setHasOnSubmitError(false);
            setValue(value);
            validateSelf(value);
        }, [setValue, isDirty, hasOnSubmitError]);
        var handleBlur = useCallback(function (value) {
            setValue(value, true);
            setTouched(false);
        }, []);
        var handleFocus = useCallback(function () {
            setTouched(true);
        }, []);
        var errors = useMemo(function () {
            if (!error || touched) {
                return [];
            }
            if (isDirty || hasOnSubmitError) {
                return [error];
            }
            return [];
        }, [error, touched, isDirty, hasOnSubmitError]);
        return (React.createElement("div", { ref: wrapperRef },
            React.createElement(EnhancedComponent, __assign({}, props, field, { errors: errors, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus }))));
    };
    WithFormikField.displayName = "".concat(getDisplayName(EnhancedComponent), "_withFormik");
    return WithFormikField;
}
